// import 'bootstrap/js/dist/modal'
// import '../../../vendor/jquery.magnific-popup-update'

import { _query, query } from '../utils/query.js'
// import ajaxGetCountryCode from '../utils/ajax-get-country-code'
import { setCookie, getCookie } from '../utils/cookie.js'

// import { transitionEndEventName } from '../utils/getTransitionEndEventName'

export class CookieBannerOption {
	// eslint-disable-next-line no-useless-constructor
	constructor() {
		// if (
		// 	getCookie('analyticsCookies') !== '' &&
		// 	getCookie('targetingCookies') !== ''
		// ) {
		// 	CookieBannerOption.sendCookieChoose()
		// } else {
		// 	CookieBannerOption.sendCountryCode()
		// }
	}

	init(config) {
		this._config = config || {}
	}

	static showBannerPopup(src) {
		$.magnificPopup.open(
			{
				items: {
					src: src || '#CookieBanner__Popup',
				},
				modal: src ? window.cookieBannerOption.forceModal : false,
				callbacks: {
					open() {
						window.scrollTo(0, 0)
						document.documentElement.classList.add('of-a')
						document.body.classList.add('vex-open')
					},
					close() {
						document.documentElement.classList.remove('of-a')
						document.body.classList.remove('vex-open')
					},
				},
			},
			0
		)
	}

	static closeBanner() {
		if ($.magnificPopup) $.magnificPopup.close()
		const cookieBanner = _query('#cookie-banner')
		if (cookieBanner) cookieBanner.style.display = 'none'
	}

	static closeCookieBanner() {
		CookieBannerOption.closeBanner()
		CookieBannerOption.submitChoose(1,1,1)
	}

	static openSetCookiePage(activePageNumber) {
		const hiddenPage = document.querySelector(`.CookieBanner__Modal__page${1-activePageNumber}`)
		const activatedPage = document.querySelector(`.CookieBanner__Modal__page${activePageNumber}`)
		const nav = document.querySelector(`.CookieBanner__Nav`)
		if (hiddenPage) hiddenPage.style.display = 'none'
		if (activatedPage) activatedPage.style.display = 'block'
		if(activePageNumber===1) {
			nav.style.display = 'flex'
		} else {
			nav.style.display = 'none'
		}

	}

	static submitChoose(analytics, targeting, preferences) {
		const AnalyticsCookiesField = _query('#AnalyticsCookies')
		const TargetingCookiesField = _query('#TargetingCookies')
		const PreferencesCookiesField = _query('#PreferencesCookies')
		// const countryCode = window.cookieData.langCode

		const AnalyticsCookies =
			analytics !== undefined ? analytics :
				AnalyticsCookiesField.checked ?
				1 :
				0
		const TargetingCookies =
			targeting !== undefined ? targeting :
				TargetingCookiesField.checked ?
				1 :
				0
		const PreferencesCookies =
				preferences !== undefined ? preferences :
			(PreferencesCookiesField.checked ?
				1 :
				0)

		// const submitData = {
		// 	analytics: Number(AnalyticsCookies),
		// 	targeting: Number(TargetingCookies),
		// 	countryCode,
		// }
		// console.debug(submitData)
		CookieBannerOption.closeBanner()

		setCookie('viewedCookieBanner', 1, 90, '', true)
		// setCookie('analyticsCookies', AnalyticsCookies, 90, '', true)
		// setCookie('targetingCookies', TargetingCookies, 90, '', true)

		const analyticsConsent = Boolean(AnalyticsCookies)
		const marketing = Boolean(TargetingCookies)
		// const _necessary = necessary ? Boolean(necessary) : Boolean(true)
		const _preferences = Boolean(PreferencesCookies)
		const consentData = {
			necessary: true,
			analytics: analyticsConsent.valueOf(),
			preferences: _preferences.valueOf(),
			marketing: marketing.valueOf(),
		}

		console.debug(AnalyticsCookies, TargetingCookies, PreferencesCookies)
		console.debug(consentData)
		setConsent(consentData)
		// return window.dataLayer.push(submitData)
	}

	static setClassToBtn() {
		const customizeBtn = _query('#Customize__Cookies')
		const AnalyticsCookiesField = _query('#AnalyticsCookies')
		const TargetingCookiesField = _query('#TargetingCookies')
		const AnalyticsCookies = AnalyticsCookiesField.checked ? 1 : 0
		const TargetingCookies = TargetingCookiesField.checked ? 1 : 0
		customizeBtn.setAttribute(
			'class',
			`Btn--Secondary mt-40 Analytics${AnalyticsCookies}__Targeting${TargetingCookies}`
		)
	}
}

// const cookieBannerOption = new CookieBannerOption()

window.showBannerPopup = CookieBannerOption.showBannerPopup
window.submitChoose = CookieBannerOption.submitChoose
window.setClassToBtn = CookieBannerOption.setClassToBtn
window.closeCookieBanner = CookieBannerOption.closeCookieBanner
window.openSetCookiePage = CookieBannerOption.openSetCookiePage

export default CookieBannerOption
